import { Component, Input, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

import { ModalComponent } from '../modal/modal.component';
import { MatDialogRef } from '@angular/material/dialog';
import { FilesTypeEnum } from '@app/ips/models/enum/files-type.enum';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.sass'],
  animations: [
    trigger('carouselAnimation', [
      transition('void => *', [style({ opacity: 0 }), animate('600ms', style({ opacity: 1 }))]),
      transition('* => void', [animate('600ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class CarouselComponent implements OnInit {
  @Input() data: any[];
  @Input() index = 0;
  allowedTypes = [FilesTypeEnum.Image, FilesTypeEnum.Video];

  currentMidia = 0;
  fileType = FilesTypeEnum;

  constructor(private dialogRef: MatDialogRef<ModalComponent>) {}

  ngOnInit(): void {
    this.currentMidia = this.index;
  }

  trackByFn(index: number): number {
    return index;
  }

  private findNextIndex(currentIndex: number, direction: number) {
    let index = currentIndex + direction;

    if (index >= this.data.length) {
      index = 0;
    }

    while (index >= 0 && index < this.data.length) {
      if (
        this.data[index]?.type === this.fileType.Image ||
        this.data[index]?.type === this.fileType.Video
      ) {
        return index;
      }
      index += direction;

      if (index < 0) {
        index = this.data.length - 1;
      }
    }
    return currentIndex;
  }

  onPrevious() {
    this.currentMidia = this.findNextIndex(this.currentMidia, -1);
  }

  onNext() {
    this.currentMidia = this.findNextIndex(this.currentMidia, 1);
  }

  onClose() {
    this.dialogRef.close();
  }
}
